"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmailIds = void 0;
const user_ids_1 = require("./src/user-ids");
Object.defineProperty(exports, "getEmailIds", { enumerable: true, get: function () { return user_ids_1.getEmailIds; } });
